import '@/App.css';
import { Toaster } from 'sonner';
import { useCalculator } from '@/hooks/useCalculator';
import { HeroSection } from '@/components/calculator/HeroSection';
import { IntroText } from '@/components/calculator/IntroText';
import { CostParameters } from '@/components/calculator/CostParameters';
import { CostComparison } from '@/components/calculator/CostComparison';
import { ComparisonChart } from '@/components/calculator/ComparisonChart';
import { CostBreakdown } from '@/components/calculator/CostBreakdown';
import { RiskPosition } from '@/components/calculator/RiskPosition';
import { ActionButtons } from '@/components/calculator/ActionButtons';
import { FooterCTA } from '@/components/calculator/FooterCTA';

function App() {
  const { mode, setMode, riskIndex, setRiskIndex, values, setters, calculated } = useCalculator();

  return (
    <div className="min-h-screen bg-slate-50">
      <Toaster position="top-center" richColors />

      <HeroSection />
      <IntroText />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-5">
            <CostParameters mode={mode} setMode={setMode} values={values} setters={setters} />
          </div>

          <div className="lg:col-span-7">
            <CostComparison
              managedCost={values.managedCost}
              selfDeliveryCostInclusive={calculated.selfDeliveryCostInclusive}
              totalCosts={calculated.totalCosts}
            />
            <ComparisonChart
              managedCost={values.managedCost}
              selfDeliveryRate={values.selfDeliveryRate}
              holidayAmount={calculated.holidayAmount}
              supervisorCost={values.supervisorCost}
              nonProductiveAmount={calculated.nonProductiveAmount}
              nonEssentialAmount={calculated.nonEssentialAmount}
            />
            <CostBreakdown
              holidayPay={values.holidayPay}
              holidayAmount={calculated.holidayAmount}
              supervisorCost={values.supervisorCost}
              nonProductiveTime={values.nonProductiveTime}
              nonProductiveAmount={calculated.nonProductiveAmount}
              nonEssentialDowntime={values.nonEssentialDowntime}
              nonEssentialAmount={calculated.nonEssentialAmount}
              totalCosts={calculated.totalCosts}
            />
          </div>
        </div>

        <RiskPosition
          riskIndex={riskIndex}
          setRiskIndex={setRiskIndex}
          selfDeliveryCostInclusive={calculated.selfDeliveryCostInclusive}
          managedCost={values.managedCost}
          riskOption={calculated.riskOption}
          riskAllowance={calculated.riskAllowance}
          adjustedSelfDelivery={calculated.adjustedSelfDelivery}
        />

        <ActionButtons values={values} calculated={calculated} />
        <FooterCTA />
      </div>
    </div>
  );
}

export default App;
